// React import
import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
// Action imports
import {hideNotification, showNotification} from "../../actions";
// Svg icons import
import { ReactComponent as CopySvg } from '../../svg-icons/copy.svg';
// Styles imports
import './TokenAnalyzerTokenAddress.css';
import '../../util.css'

async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
        return await navigator.clipboard.writeText(text);
    } else {
        return document.execCommand('copy', true, text);
    }
}

class TokenAnalyzerTokenAddress extends React.Component {

    constructor(props) {
        super(props);
    }

    setNotification = () => {
        const { showNotification, hideNotification } = this.props;
        const duration = 750;

        showNotification({message: "Token address copied", duration: duration});
        setTimeout(() => {
            hideNotification();
        }, duration);
    }

    handleClick = async () => {
        const {address} = this.props.tokenAnalyzer;
        await copyTextToClipboard(address);
        this.setNotification();
    };

    render () {

        const { shortAddress } = this.props.tokenAnalyzer;

        return(
            <div className={"token-analyzer__addr"}>
                <span className={"token-analyzer__addr__label noselect"}>{shortAddress}</span>

                <div className={"token-analyzer__addr__copy-icon-block"} onClick={this.handleClick}>
                    <CopySvg className={"token-analyzer__addr__copy-icon"}/>
                </div>
            </div>
        );
    }

}

const mapStateToProps = ({tokenAnalyzer, notification}) => {
    return {tokenAnalyzer, notification};
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        showNotification: showNotification,
        hideNotification: hideNotification
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(TokenAnalyzerTokenAddress);